import styled from "@emotion/styled";

export const ResponsivePicCard = styled.img`
  width: clamp(250px, 40vw, 600px);
  height: clamp(150px, 20vw, 300px);
  border-radius: clamp(8px, 1vw, 16px);
  object-fit: cover;
  display: block;
`;
